import React from 'react';
import PropTypes from 'prop-types';
import { Divider } from 'antd';

import CheckRows from '../CheckRows';
import UserAssignmentSelector from '../../forms/FormWorkflows/selectors/UserAssignmentSelector';
import Colors from '../../constants/Colors';

const tokenSeparators = [',', '\n'];

const dividerStyle = {
  margin: 0,
  backgroundColor: Colors.ONTRACCR_OPACITY_GRAY,
  maxWidth: 440,
  minWidth: 440,
};

export default function NotificationRecipientGroup({
  setting,
  isEnabled,
  onToggle,
  recipients,
  onRecipientsChange,
  recipientLabel,
  additionalOptions,
  showDivider,
}) {
  return (
    <>
      <CheckRows
        data={[{ ...setting, divider: false, useSwitch: true }]}
        isChecked={() => isEnabled}
        onChange={onToggle}
      />
      {isEnabled && (
        <UserAssignmentSelector
          onChange={onRecipientsChange}
          selected={recipients}
          mode="tags"
          showPositions
          type="email"
          text={recipientLabel}
          tokenSeparators={tokenSeparators}
          additionalOptions={additionalOptions}
        />
      )}
      {showDivider && <Divider style={dividerStyle} />}
    </>
  );
}

NotificationRecipientGroup.propTypes = {
  setting: PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    helpText: PropTypes.string,
  }).isRequired,
  isEnabled: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  recipients: PropTypes.arrayOf(PropTypes.string),
  onRecipientsChange: PropTypes.func.isRequired,
  recipientLabel: PropTypes.string.isRequired,
  additionalOptions: PropTypes.arrayOf(PropTypes.shape({})),
  showDivider: PropTypes.bool,
};

NotificationRecipientGroup.defaultProps = {
  isEnabled: false,
  recipients: [],
  additionalOptions: [],
  showDivider: true,
};
